import React from 'react';

const Warning = ({ color }) => {
  return (
    <svg viewBox="0 0 14 12" version="1.1">
      <defs>
        <path
          d="M0.583333333,12.25 L13.4166667,12.25 L7,1.16666667 L0.583333333,12.25 Z M7.58333333,10.5 L6.41666667,10.5 L6.41666667,9.33333333 L7.58333333,9.33333333 L7.58333333,10.5 Z M7.58333333,8.16666667 L6.41666667,8.16666667 L6.41666667,5.83333333 L7.58333333,5.83333333 L7.58333333,8.16666667 Z"
          id="path-error"
        />
      </defs>
      <g
        id="Van-Temperature"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="iPad---Van-Details---Confirm-Temp---Too-Hot"
          transform="translate(-201.000000, -344.000000)"
        >
          <g id="💎-Icon/Warning" transform="translate(201.000000, 343.000000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-error" />
            </mask>
            <use
              id="Icon"
              fill={color}
              fillRule="evenodd"
              xlinkHref="#path-error"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Warning;
